import { render, staticRenderFns } from "./UnitItemHorizontal.vue?vue&type=template&id=55b77132&scoped=true&"
import script from "./UnitItemHorizontal.vue?vue&type=script&lang=js&"
export * from "./UnitItemHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./UnitItemHorizontal.vue?vue&type=style&index=0&id=55b77132&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b77132",
  null
  
)

export default component.exports